import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import {
	AnalyticsService,
	AnalyticsEvent,
} from 'src/app/shared/services/analytics/analytics.service';
import { ButtonComponent } from 'src/app/ui/button/button.component';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { MatterPackageHistoryComponent } from '../../matter-package-history/matter-package-history.component';
import { SetCurrentPackageId } from 'src/app/shared/state/matter/matter-packages-history/matter-packages-history.actions';
import { dispatch } from '@ngxs/store';

@Component({
	selector: 'app-matter-package-history-button',
	templateUrl: './matter-package-history-button.component.html',
	imports: [ButtonComponent, CommonModule],
})
export class MatterPackageHistoryButtonComponent {
	private analytics = inject(AnalyticsService);
	private drawerService = inject(DrawerService);
	private SetCurrentPackageId = dispatch(SetCurrentPackageId);

	public date_ = input<Date | string>();
	public dataIntercomTarget_ = input<string>(null);
	public packageId_ = input.required<string>();

	gotoPackageHistory() {
		const packageId = this.packageId_();
		this.analytics.logEvent(AnalyticsEvent.MATTER_PACKAGE_HISTORY);
		this.SetCurrentPackageId({ currentPackageId: packageId });
		this.drawerService.openDrawer(MatterPackageHistoryComponent, {
			title: 'Package History',
			size: 'md',
			data: { packageId },
		});
	}
}
